export default "__VITE_ASSET__Db86jORM__"